// extracted by mini-css-extract-plugin
export default {"body":"body_body__iFLwo","content":"body_content__Z1lyL","headerText":"body_headerText__k21Vs"};